import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import React from 'react'
import styled from 'styled-components'

const ModalFooter: React.FC<BoxProps> = ({ children, ...props }) => {
  return <StyledFooterContainer {...props}>{children}</StyledFooterContainer>
}

const StyledFooterContainer = styled(Box)`
  width: 100%;
  padding: 20px;
  display: flex;
  align-items: center;
`

export default ModalFooter
